module.exports = new __parcel__URL__("smartsheet-logomark.e22f08e8.svg").toString();